module.exports = __webpack_public_path__ + "img/warayaki.69319017.jpeg";